import { Injectable } from '@angular/core';
import { CanActivate, CanLoad, Router } from '@angular/router';

import { LocalStorageService } from 'src/app/common/services/local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate, CanLoad {
  constructor(private localStorageService: LocalStorageService, private router: Router) {}

  canLoad(): Promise<boolean> {
    if (this.localStorageService.get('sessionToken')) return Promise.resolve(true);

    // this.router.navigate(['/login']);
    return Promise.resolve(true);
  }

  canActivate(): Promise<boolean> {
    if (this.localStorageService.get('sessionToken')) return Promise.resolve(true);

    // this.router.navigate(['/login']);
    return Promise.resolve(true);
  }
}
